import { Card, CardContent } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { User } from 'lucide-react'

interface AttendantMetricsCardProps {
  name: string
  odataId: number
  frt: number | null // seconds
  tmr: number | null // seconds
  messageCount: number
  responseCount: number
  ticketCount: number
  onClick?: () => void
}

function formatTime(seconds: number | null): string {
  if (seconds === null) return 'N/A'
  if (seconds < 60) return `${seconds.toFixed(0)}s`
  return `${(seconds / 60).toFixed(1)}min`
}

export function AttendantMetricsCard({
  name,
  frt,
  tmr,
  messageCount,
  responseCount,
  ticketCount,
  onClick,
}: AttendantMetricsCardProps) {
  const initials = (name || 'N/A')
    .split(' ')
    .map((n) => n[0])
    .join('')
    .substring(0, 2)
    .toUpperCase()

  return (
    <Card
      className={`${onClick ? 'cursor-pointer hover:shadow-md hover:border-primary/50 transition-all' : ''}`}
      onClick={onClick}
    >
      <CardContent className="p-4">
        <div className="flex items-start gap-3">
          {/* Avatar */}
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10 text-primary font-semibold shrink-0">
            <User className="h-5 w-5" />
          </div>

          {/* Content */}
          <div className="flex-1 min-w-0 space-y-3">
            <div>
              <h3 className="font-semibold truncate">{name || 'Sem nome'}</h3>
              <p className="text-xs text-muted-foreground">ID: {initials}</p>
            </div>

            {/* Metrics Grid 2x3 */}
            <div className="grid grid-cols-2 gap-2 text-sm">
              <div>
                <p className="text-muted-foreground text-xs">FRT</p>
                <p className="font-semibold">{formatTime(frt)}</p>
              </div>
              <div>
                <p className="text-muted-foreground text-xs">TMR</p>
                <p className="font-semibold">{formatTime(tmr)}</p>
              </div>
              <div>
                <p className="text-muted-foreground text-xs">Mensagens</p>
                <Badge variant="outline">{messageCount}</Badge>
              </div>
              <div>
                <p className="text-muted-foreground text-xs">Respostas</p>
                <Badge variant="outline">{responseCount}</Badge>
              </div>
              <div>
                <p className="text-muted-foreground text-xs">Tickets</p>
                <Badge variant="outline">{ticketCount}</Badge>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
